import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1556.61126,1920 C1502.52719,1920 1448.44311,1899.30791 1407.2779,1858.14271 L740.094984,1190.95979 C541.93268,1232.6724 333.369592,1171.69097 189.619809,1027.94118 C14.4487116,852.770087 -35.2560874,582.787632 65.7957397,356.269506 L98.2023928,283.573501 L488.396013,673.767121 C512.810485,698.072111 552.66191,698.072111 577.076381,673.767121 L687.762619,563.080884 C699.586668,551.147353 706.046102,535.491436 706.046102,518.740699 C706.046102,501.989963 699.586668,486.224564 687.762619,474.400515 L297.568998,84.2068949 L370.265004,51.8002418 C596.892612,-49.2515852 866.875066,0.453213761 1041.93668,175.51483 C1196.9631,330.650733 1254.76957,560.672281 1193.78813,770.330189 L1844.43927,1420.98134 C1884.40018,1460.83276 1906.40605,1513.9315 1906.40605,1570.42418 C1906.40605,1626.80738 1884.40018,1679.90611 1844.43927,1719.75754 L1706.16359,1858.14271 C1664.8889,1899.30791 1610.80482,1920 1556.61126,1920 L1556.61126,1920 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAdminToolsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAdminToolsSolid, _Component);

  var _super = _createSuper(IconAdminToolsSolid);

  function IconAdminToolsSolid() {
    _classCallCheck(this, IconAdminToolsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAdminToolsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAdminTools",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAdminToolsSolid.displayName = "IconAdminToolsSolid";
  return IconAdminToolsSolid;
}(Component);

IconAdminToolsSolid.glyphName = 'admin-tools';
IconAdminToolsSolid.variant = 'Solid';
IconAdminToolsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAdminToolsSolid;
export { IconAdminToolsSolid };